import '@jakarto3d/jakui/dist/jakui.css'
import '@/styles/main.css'
import { createApp } from 'vue'
import App from '@/App.vue'
import { createPinia } from 'pinia'
import { initializeApp } from "firebase/app"

// Font Awesome imports
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTree, faFireFlameSimple, faHouse, faTowerCell, faBug, faLocationDot, faDrawPolygon, faLayerGroup } from '@fortawesome/free-solid-svg-icons'

import '@/styles/cesium-overrides.css'

// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDK1-cCTL-FQH0WQ48XHReiE-c91EU1pT8",
    authDomain: "itwin-activate.jakarto.com",
    projectId: "bentley-1twin-activate",
    storageBucket: "bentley-1twin-activate.firebasestorage.app",
    messagingSenderId: "773328305684",
    appId: "1:773328305684:web:4f05dae102ec9ab576b101"
}

initializeApp(firebaseConfig)

// Add icons to library
library.add(faTree, faFireFlameSimple, faHouse, faTowerCell, faBug, faLocationDot, faDrawPolygon, faLayerGroup)

const app = createApp(App)

// Use Pinia Store
const pinia = createPinia()

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(pinia)
app.mount('#app')
